import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { EMlpIconTypes, EMplVariantTypes, MplIconMessage } from '@mopla/ui';

interface IStep1ContentProps {
	startDate: string;
	showValidityWarning: boolean;
	daysRemaining: number;
}

export const Step1Content: FC<IStep1ContentProps> = ({
	startDate,
	showValidityWarning,
	daysRemaining,
}) => {
	const { t } = useTranslation('subscribeDTicket');

	const formattedDate = dayjs(startDate).format('DD. MMMM YYYY');
	const currentMonthName = dayjs(startDate).format('MMMM');

	return (
		<Stack gap={2}>
			<Typography variant="h4-sb" color="primary.main">
				{t('step1.title')}
			</Typography>

			<Stack gap={1}>
				<Typography variant="b1-m" color="primary.main">
					<Trans
						i18nKey="subscribeDTicket:step1.valid_from"
						values={{ date: formattedDate }}
						components={{
							bold: <strong />,
						}}
					/>
				</Typography>

				<Typography
					variant="b2"
					color="solutions.600"
					sx={{ whiteSpace: 'pre-line' }}
				>
					{t('step1.description')}
				</Typography>
			</Stack>

			{showValidityWarning && (
				<MplIconMessage
					type={EMlpIconTypes.Warning}
					variant={EMplVariantTypes.Warning}
					message={
						<Trans
							i18nKey="subscribeDTicket:step1.validity_warning"
							values={{
								days: daysRemaining,
								month: currentMonthName,
							}}
							components={{
								bold: <strong />,
							}}
						/>
					}
				/>
			)}
		</Stack>
	);
};
